import React from 'react';
import { Control, Controller } from 'react-hook-form';
import { BaseCard, BaseCardProps } from '@/components/uiKit/Cards';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { UserProfileFormData } from '@/components/pages/SettingsPage/MainContent/shared/UserDetailsForm/UserDetailsForm';

const ROLE_OPTIONS = [
  { value: 'admin', label: 'Admin' },
  { value: 'member', label: 'Member' },
] as const;

interface RoleSectionProps {
  control: Control<UserProfileFormData, any>;
}

export const RoleSection = ({ control }: RoleSectionProps) => (
  <BaseCard
    variant="wrapper"
    title="Permission and Role"
    classNames={{
      card: `w-full`,
      title: 'h-[30px]',
      content: 'h-[calc(100%-30px)] rounded-lg overflow-y-hidden flex flex-row p-6',
    }}
  >
    <div className="flex flex-col w-1/4 gap-4">
      <Controller
        name="role"
        control={control}
        render={({ field }) => (
          <Select value={field.value} onValueChange={field.onChange}>
            <SelectTrigger className="w-[325px] focus:outline-none focus:ring-0 focus:ring-offset-0 border-0 rounded-none border-b-2 focus:border-b-2 hover:border-b-neutral-100">
              <SelectValue placeholder="Select a role" />
            </SelectTrigger>
            <SelectContent>
              {ROLE_OPTIONS.map((role) => (
                <SelectItem key={role.value} value={role.value}>
                  {role.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        )}
      />
    </div>
  </BaseCard>
);
